import * as React from 'react';
import { Button, ModalWindow, useDeviceType } from '@cian/ui-kit';

import * as styles from './ResultModalWindow.css';

export interface IResultModalWindowProps {
  open: boolean;
  textContent: React.ReactNode;
  'data-testid'?: string;
  onClose: () => void;
}

export const ResultModalWindow: React.FC<IResultModalWindowProps> = ({
  open,
  textContent,
  'data-testid': dataTestId,
  onClose,
}) => {
  const deviceType = useDeviceType();

  const isPhone = deviceType === 'phone';
  const height = isPhone ? '100%' : undefined;

  return (
    <ModalWindow
      escape
      footer={
        <div className={styles['button-wrapper']} data-testid="ThanksButton">
          <Button onClick={onClose} fullWidth={isPhone}>
            Спасибо, жду
          </Button>
        </div>
      }
      height={height}
      onClose={onClose}
      open={open}
      outside
      print
      size="M"
      width={688}
    >
      <div className={styles['result-modal-content-wrapper']} data-testid={dataTestId}>
        <div className={styles['result-modal-content']}>
          <div className={styles['image']} />
          {textContent}
        </div>
      </div>
    </ModalWindow>
  );
};
